import { render } from "./MaterialLibrary.vue?vue&type=template&id=7948c66e&scoped=true"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js"

import "./MaterialLibrary.vue?vue&type=style&index=0&id=7948c66e&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7948c66e"]])

export default __exports__